// Stripe configuration
export const STRIPE_PUBLISHABLE_KEY = 'pk_live_51NhNiGL8waXIEe9pXuo7hQPpaIPaMqvvRERhIQUwrtStz0KVo2dixzB4X0kcQyR7cS1QdH0Z2tChLwkH3ZjQCGkg00ZbJVchdg'

